export class PedidoAnexo {
  id: number;
  idCupom: string;
  idAnexo: number;
  descricao: string;
  arquivo: string;
  origem: number;
  idUsuario: number;
  tipo: number;
  dataHora: Date;
  nomeUsuario: string;
  comprovantePagamento: boolean;
  valorComprovante?: number;
  statusExc: boolean;
  dataHoraExc?: Date;
  nomeUsuarioExc: string;
}
